<template>
  <div>
    <!-- desktop -->
    <NuxtImg class="hidden md:block w-full"
      v-if="mediaData.image.url"
      :src="toImgixPath(mediaData.image.url)"
      fetchpriority="high"
      loading="lazy"
      width="1440"
      height="490"
      provider="imgix"
      format="webp"
      fit="crop"     
      :alt="mediaData.image.altText"
      :modifiers="{ 
        ar: '1440:490',
        auto: 'format,compress',        
        'fp-x': mediaData.presentation ? mediaData.presentation.asJson.focalPoint.x : 0.5,
        'fp-y': mediaData.presentation ? mediaData.presentation.asJson.focalPoint.y : 0.5,
      }"/>
      <!-- mobile -->
      <NuxtImg class="block md:hidden w-full"
      v-if="mediaData.image.url"
      :src="toImgixPath(mediaData.image.url)"
      fetchpriority="high"
      loading="lazy"
      :width="Number(412)"
      :height="Number(308)"
      :sizes="'412px sm:640px'"
      provider="imgix"
      format="webp"
      fit="crop"
      :alt="mediaData.image.altText"      
      :modifiers="{ 
        ar: '16:12',
        auto: 'format,compress',        
        'fp-x': mediaData.presentation ? mediaData.presentation.asJson.focalPoint.x : 0.5,
        'fp-y': mediaData.presentation ? mediaData.presentation.asJson.focalPoint.y : 0.5,
      }"/>
  </div>
  </template>
  
    
<script setup>
    import { useImageUtils } from '@/composables/useImageUtils';
    const {toImgixPath} = useImageUtils();
    
    // Props
    const props = defineProps({
      mediaData: {
        type: Object,
        required: true
      },
      alt: {
        type: String,
        default: 'Image'
      },
      width: {
        type: [String, Number],
        default: 1440
      },
      height: {
        type: [String, Number],
        default: 405
      },
      sizes: {
        type: String,
        default: 'sm:100vw md:480px lg:720px xl:960px'
      }
    });
    


    
    </script>
    
    <style scoped>
   
    </style>